import React from 'react';
import { Box, Chip, Typography, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface FilterTag {
  category: string;
  value: string;
  displayCategory: string;
}

interface FilterTagsProps {
  rangeList: string[];
  colourList: string[];
  designList: string[];
  typesList: string[];
  brandList: string[];
  materialList: string[];
  standardsList: string[];
  compositionList: string[];
  performanceList: string[];
  sizeList: string[];
  shapeList: string[];
  onRemoveFilter: (category: string, value: string) => void;
  onClearAll: () => void;
}

const FilterTags: React.FC<FilterTagsProps> = ({
                                                 rangeList,
                                                 colourList,
                                                 designList,
                                                 typesList,
                                                 brandList,
                                                 materialList,
                                                 standardsList,
                                                 compositionList,
                                                 performanceList,
                                                 sizeList,
                                                 shapeList,
                                                 onRemoveFilter,
                                                 onClearAll,
                                               }) => {
  const filterTags: FilterTag[] = [
    ...rangeList.map(value => ({ category: 'range', value, displayCategory: 'Collection' })),
    ...brandList.map(value => ({ category: 'brand', value, displayCategory: 'Brand' })),
    ...designList.map(value => ({ category: 'design_style', value, displayCategory: 'Design' })),
    ...standardsList.map(value => ({ category: 'standards', value, displayCategory: 'Standards' })),
    ...compositionList.map(value => ({ category: 'composition', value, displayCategory: 'Composition' })),
    ...performanceList.map(value => ({ category: 'performance', value, displayCategory: 'Performance' })),
    ...colourList.map(value => ({ category: 'colours', value, displayCategory: 'Colour' })),
    ...typesList.map(value => ({ category: 'types', value, displayCategory: 'Type' })),
    ...materialList.map(value => ({ category: 'material', value, displayCategory: 'Material' })),
    ...sizeList.map(value => ({ category: 'sizes', value, displayCategory: 'Size' })),
    ...shapeList.map(value => ({ category: 'shapes', value, displayCategory: 'Shape' })),
  ];

  if (filterTags.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      {/* Heading appears only when filters are active (matches trade) */}
      <Typography fontWeight="bold" fontSize="18px" mb={1.5}>
        Filters
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
          alignItems: 'center',
        }}
      >
        {/* Active Filter Chips */}
        {filterTags.map((tag, index) => (
          <Chip
            key={`${tag.category}-${tag.value}-${index}`}
            label={tag.value}
            onDelete={() => onRemoveFilter(tag.category, tag.value)}
            deleteIcon={<CloseIcon sx={{ color: '#fff !important' }} />}
            size="medium"
            sx={{
              backgroundColor: '#000',
              color: '#fff',
              borderRadius: '20px',
              fontSize: '14px',
              fontWeight: 500,
              height: '36px',
              '& .MuiChip-label': {
                paddingLeft: '14px',
                paddingRight: '6px',
              },
              '&:hover': {
                backgroundColor: '#333',
              },
            }}
          />
        ))}

        {/* Clear All Pill Box */}
        <Chip
          label="Clear all"
          onClick={onClearAll}
          onDelete={onClearAll}
          deleteIcon={<CloseIcon sx={{ color: '#000 !important' }} />}
          variant="outlined"
          size="medium"
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            borderColor: '#ccc',
            borderRadius: '20px',
            fontSize: '14px',
            fontWeight: 600,
            height: '36px',
            cursor: 'pointer',
            '& .MuiChip-label': {
              paddingLeft: '14px',
              paddingRight: '6px',
            },
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        />
      </Box>
      <Divider sx={{ borderColor: '#000', borderBottomWidth: 1, mt: 2 }} />
    </Box>
  );
};

export default FilterTags;